import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';

// `item` = { name, price } or null. onConfirm(priceNumber).
export const CustomPriceDialog = ({ item, onConfirm, onClose, L }) => {
  const [val, setVal] = useState('');
  useEffect(() => { setVal(item?.price > 0 ? String(item.price) : ''); }, [item]);
  const ok = () => { const n = parseFloat(val); if (isFinite(n) && n > 0) onConfirm(Math.round(n * 100) / 100); };
  return (
    <Dialog open={!!item} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-sm" data-testid="custom-price-dialog">
        <DialogHeader>
          <DialogTitle>{L('Individual price', 'Individueller Preis')}</DialogTitle>
          <DialogDescription>{item?.name}{item?.price > 0 && ` · ${L('List', 'Listenpreis')} ${Number(item.price).toFixed(2)} CHF`}</DialogDescription>
        </DialogHeader>
        <Input type="number" inputMode="decimal" step="0.5" min="0" autoFocus value={val}
          onChange={(e) => setVal(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') ok(); }}
          className="text-lg font-bold" placeholder="0.00" data-testid="custom-price-input" />
        <div className="flex gap-3 pt-2">
          <Button variant="outline" onClick={onClose} className="flex-1">{L('Cancel', 'Abbrechen')}</Button>
          <Button onClick={ok} disabled={!(parseFloat(val) > 0)} className="flex-1 bg-emerald-500 text-white hover:bg-emerald-600 font-bold" data-testid="custom-price-confirm">{L('Apply', 'Übernehmen')}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
